<script>
import Layout from "../../layouts/main";
import ContactUsAPI from "@/services/contact-us-api";

export default {
  components: {
    Layout,
  },
  data() {
    return {
      contactUs: { firstName: "", secondName: "", mail: "", message: "" },
      telephone: "(+216) 70 160 860",
      email:"hello@aps-shop.tn",
      address: "010, ENERGIE SOLAIRE-8612, CHARGUIA 1,Tunis,2035",
    };
  },
  methods: {
    sendContactUsMail() {
      ContactUsAPI.sendContactUsMail(this.contactUs);
    },
  },
};
</script>

<template>
  <Layout>
    <div class="home-page-80-width ">
      <!-- Title -->
      <div class="text-center mb-5">
        <h1 class="font-size-24 pt-5 text-center text-uppercase  font-weight-bold text-dark" style="font-size: 2.3rem;">Contactez-nous</h1>
      </div>

      <!-- Contact Form -->
      <div class="row justify-content-center ">
        <div class="col-lg-12">
          <form @submit.prevent="sendContactUsMail" class="bg-white shadow-sm p-4 rounded">
            <div class="row">
              <div class="col-md-6 mb-3 pr-md-3">
                <label class="text-info font-weight-bold">Nom</label>
                <input
                  type="text"
                  v-model="contactUs.secondName"
                  class="form-control"
                  placeholder="Nom"
                  required
                />
              </div>
              <div class="col-md-6 mb-3">
                <label class="text-info font-weight-bold">Prénom</label>
                <input
                  type="text"
                  v-model="contactUs.firstName"
                  class="form-control"
                  placeholder="Prénom"
                  required
                />
              </div>
              <div class="col-12 mb-3">
                <label class="text-info font-weight-bold">Adresse mail</label>
                <input
                  type="email"
                  v-model="contactUs.mail"
                  class="form-control"
                  placeholder="Adresse mail"
                  required
                />
              </div>
              <div class="col-12 mb-4">
                <label class="text-info font-weight-bold">Message</label>
                <textarea
                  v-model="contactUs.message"
                  class="form-control"
                  placeholder="Votre message"
                  rows="6"
                  maxlength="3000"
                  required
                ></textarea>
              </div>
            </div>

            <button type="submit" class="btn btn-primary btn-block text-uppercase font-weight-bold py-2">
              Envoyer
            </button>
          </form>
        </div>
      </div>


      <!-- Contact Info -->
      <div class="card border-0 shadow-sm mt-5 mb-5">
        <div class="card-body">
          <div class="row">
            <div class="col-12 mb-4 mb-md-0">
              <h3 class="h5 mb-4 text-primary text-uppercase">Adresse Siège SFAX</h3>

              <p>
                <img  alt="" width="16px"
                  src="@/assets/icons/map.svg"
                  class="pb-1 me-2"/> 
                <a 
                  :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`" 
                  target="_blank" 
                  class="text-decoration-none text-dark">
                  {{ address }}
                </a>
              </p>

              <p>
                 <img  alt="" width="14px"
                  src="@/assets/icons/phone.svg"
                  class="pb-1"/> 
                <a 
                  :href="`tel:${telephone}`" 
                  class="text-decoration-none text-dark">
                  Téléphone: {{ telephone }}
                </a>
              </p>

              <p>
                <img  alt="" width="15px"
                  src="@/assets/icons/mail.svg"
                  class="pb-1"/> 
                <a 
                  :href="`mailto:${email}`" 
                  class="text-decoration-none text-uppercase text-dark">
                  {{ email }}
                </a>
              </p>

              <p>
                 <img  alt="" width="12px"
                  src="@/assets/icons/clock.svg"
                  class="pb-1"/>
                 Lun-Ven, 9h-17h
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
